/**
 * Kami for Google Chrome
 *
 * Exposes its Schoology and Google Classroom integration scripts to every origin,
 * rather than only to the LMS domains they are meant for.
 * Manifest verified against version 2.0.24609.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ecnphlgnajanjnkcmbpancdjoidceilk';
export const kami: ExtensionDefinition = {
  id: ID,
  name: 'Kami for Google Chrome™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'Its LMS integration scripts are exposed to <all_urls> rather than scoped to the ' +
    'LMS domains — an education extension, so the population it identifies is largely students.',
  signals: [
    { id: 'war-schoology-script', kind: 'web-accessible-resource',
      description: 'Fetch schoology_page_script.js — the Schoology integration, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'schoology_page_script.js') },
    { id: 'war-classroom-styles', kind: 'web-accessible-resource',
      description: 'Fetch assets/google_classroom_styles.css to corroborate.',
      weight: 0.5, run: () => probeFetch(ID, 'assets/google_classroom_styles.css') },
  ],
};
